export const EVENTS = {
    CHECK_PERSON_STEP: 'check_person_step_event',
    CREATE_PERSON_STEP: 'create_person_step_event',
    INSTALLMENTS_STEP: 'installments_step_event',
    INSTALLMENTS_STEP_AMOUNT: 'installments_step_amount_event'
};
